// client/src/tmApi.js
import { auth } from './firebaseConfig';

const BASE = (process.env.REACT_APP_TM_API_BASE || '').replace(/\/+$/, '');

async function getIdToken() {
  const u = auth.currentUser;
  if (!u) throw new Error('Not signed in');
  return await u.getIdToken();
}

async function authFetch(path, options = {}) {
  const token = await getIdToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

// ----- product (legacy) -----
export async function listCategories() {
  const res = await fetch(`${BASE}/categories`);
  if (!res.ok) throw new Error('Failed to load categories');
  return res.json();
}
export async function getAvailability(slug) {
  const res = await fetch(`${BASE}/categories/${encodeURIComponent(slug)}/availability`);
  if (!res.ok) throw new Error('Failed to load availability');
  return res.json();
}

// ----- dataset-agnostic pricing/orders -----
export async function getPrice(body) {
  return authFetch('/price', { method: 'POST', body: JSON.stringify(body) });
}
export async function createOrder(body) {
  return authFetch('/orders/create', { method: 'POST', body: JSON.stringify(body) });
}
export async function verifyAndGenerate(body) {
  return authFetch('/orders/verify', { method: 'POST', body: JSON.stringify(body) });
}
export async function getReportDownloadUrl(purchaseId) {
  return authFetch(`/my-reports/${encodeURIComponent(purchaseId)}/download`, { method: 'GET' });
}

// ----- generic entities (state/ministry) -----
export async function listEntities(dataset, search = '') {
  const url = search
    ? `${BASE}/ds/${dataset}/entities?search=${encodeURIComponent(search)}`
    : `${BASE}/ds/${dataset}/entities`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to load ${dataset} entities`);
  return res.json();
}
export function listStates(search = '') {
  return listEntities('state', search);
}

// dataset-aware wrappers
export async function getPriceDS(body) {
  return authFetch('/price', { method: 'POST', body: JSON.stringify(body) });
}
export async function createOrderDS(body) {
  return authFetch('/orders/create', { method: 'POST', body: JSON.stringify(body) });
}
export async function verifyAndGenerateDS(body) {
  return authFetch('/orders/verify', { method: 'POST', body: JSON.stringify(body) });
}

// ---------- MINISTRY helpers ----------
export async function searchMinistryEntities(q, limit = 20) {
  const url = `${BASE}/ds/ministry/search?q=${encodeURIComponent(q || '')}&limit=${encodeURIComponent(limit)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to search ministry entities');
  return res.json();
}
export function listMinistries(search = '') {
  return listEntities('ministry', search);
}

// Build filters from selection (kept for reference)
export function filtersFromMinistrySelection(sel) {
  if (!sel || !sel.type) return undefined;
  if (sel.type === 'department' && sel.dept) return { departments: [sel.dept] };
  if (sel.type === 'organisation' && sel.org) return { organisations: [sel.org] };
  return undefined;
}

// True availability for a dept/org (three-arg form)
export async function getMinistryFilterAvailability(ministrySlug, ftype, value) {
  const url =
    `${BASE}/ds/ministry/filter-availability` +
    `?ministry_slug=${encodeURIComponent(ministrySlug)}` +
    `&ftype=${encodeURIComponent(ftype)}` +
    `&value=${encodeURIComponent(value)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to load availability for selection');
  return res.json(); // {min,max,rows}
}
// ---------- STATE helpers ----------
export async function searchStateEntities(q, limit = 20) {
  const url = `${BASE}/ds/state/search?q=${encodeURIComponent(q || '')}&limit=${encodeURIComponent(limit)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to search state entities');
  return res.json();
}

export async function getStateFilterAvailability(stateSlug, ftype, value) {
  const url =
    `${BASE}/ds/state/filter-availability` +
    `?state_slug=${encodeURIComponent(stateSlug)}` +
    `&ftype=${encodeURIComponent(ftype)}` +
    `&value=${encodeURIComponent(value)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to load availability for selection');
  return res.json(); // {min,max,rows}
}
// ----- SERVICE helpers -----
export function listServiceCategories(search = '') {
  return listEntities('service', search);
}

export async function getPriceService({ slug, date_from, date_to, filters }) {
  return getPriceDS({ dataset: 'service', slug, date_from, date_to, filters });
}
export async function createOrderService({ slug, date_from, date_to, filters }) {
  return createOrderDS({ dataset: 'service', slug, date_from, date_to, filters });
}
export async function verifyAndGenerateService({
  slug, date_from, date_to, order_id, payment_id, signature, filters
}) {
  return verifyAndGenerateDS({
    dataset: 'service',
    slug,
    date_from,
    date_to,
    order_id,
    payment_id,
    signature,
    filters,
  });
}
export async function listMyReports() {
  return authFetch('/my-reports', { method: 'GET' });
}
export async function generateReportWithCombo(body) {
  // body: { dataset?, slug, date_from, date_to, rows? }
  return authFetch('/orders/combo-generate', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}


